/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsultationDto } from '../../models/consultation-dto';

export interface ConsultationAdminControllerFindByIdV1$Params {
  id: string;
}

export function consultationAdminControllerFindByIdV1(http: HttpClient, rootUrl: string, params: ConsultationAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsultationDto>> {
  const rb = new RequestBuilder(rootUrl, consultationAdminControllerFindByIdV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConsultationDto>;
    })
  );
}

consultationAdminControllerFindByIdV1.PATH = '/api/v1/consultations/admin/{id}';
